export const MESSAGES = {
  ERROR_TITLE: 'Serviço temporariamente indisponível',
  ERROR_DESCRIPTION: 'Tente novamente mais tarde',
  RELOAD: 'Recarregar',
}
